// extracted by mini-css-extract-plugin
export var displayNone = "_mh-6";
export var imgContainer = "_mh-2";
export var overflowHidden = "_mh-3";
export var productInfoCardButtonContainer = "_mh-5";
export var productTitleText = "_mh-4";
export var rightArrow = "_mh-1";
export var rightArrowContainer = "_mh-0";